import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiTypography: {
      h4: {
        fontSize: '1.15em',
        color: currentTheme.palette.tertiary.darkGrey,
      },
      overline: {
        fontSize: '0.88rem',
        lineHeight: 1.15,
        fontWeight: 500,
        color: currentTheme.palette.tertiary.lightGrey,
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#FFFFFF',
        color: '#6E727A',
        border: '1px solid #dadde9',
        padding: `12px`,
      },
      arrow: {
        color: '#dadde9',
      },
    },
  },
}))
